export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
  tone = "light",
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
  tone?: "light" | "dark";
}) {
  const isCenter = align === "center";
  const isDark = tone === "dark";
  return (
    <div
      className={`${isCenter ? "mx-auto text-center" : "text-left"} max-w-3xl mb-10 md:mb-14`}
    >
      <span
        className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium tracking-wide ${
          isCenter ? "" : ""
        } ${isDark ? "bg-background-50/10 text-accent-300" : "bg-accent-100 text-accent-700"}`}
      >
        <span
          className={`w-1.5 h-1.5 rounded-full ${isDark ? "bg-accent-400" : "bg-accent-500"}`}
        ></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 text-2xl md:text-4xl font-bold leading-snug tracking-tight ${
          isDark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            isDark ? "text-background-100/70" : "text-foreground-700"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}